import React, { Component } from 'react'
import Banner from './Banner.jsx'

class AlertBanner extends Component {
  constructor(props) {
    super(props)

    this.state = {
      display: true,
      sticky: this.props.sticky !== undefined ? this.props.sticky : false,
      displayTime:
        this.props.displayTime !== undefined ? this.props.displayTime : 8000,
      closeForSession: false,
    }
  }

  componentDidMount() {
    if (!this.state.sticky) {
      setTimeout(() => {
        this.closeClicked()
      }, this.state.displayTime)
    }

    if (JSON.parse(sessionStorage.getItem('CLOSE-LASTLOGIN'))) {
      this.setState({ closeForSession: true })
    }
  }

  closeClicked = () => {
    this.setState({ display: false })

    if (this.props.lastLogin) {
      this.setLastLoginSession()
      this.setState({ closeForSession: true })
    }
  }

  setLastLoginSession = () => {
    sessionStorage.setItem('CLOSE-LASTLOGIN', JSON.stringify(true))
  }

  render() {
    return this.state.display &&
      (!this.props.lastLogin ||
        (this.props.lastLogin && !this.state.closeForSession)) ? (
      <div>
        <Banner
          status={this.props.status}
          title={this.props.title}
          text={this.props.text}
          closeClicked={this.closeClicked}
        />
      </div>
    ) : null
  }
}

export default AlertBanner
